// extracted by mini-css-extract-plugin
export var nextStoryTitle = "NextSection-module--nextStoryTitle--2oNWr";
export var triangle = "NextSection-module--triangle--2eMS5";
export var storyLink = "NextSection-module--storyLink--1Jifh";